import FinanceApi from '@/services/FinanceApi';

const getAll = async (config) => {
    return FinanceApi.get('/product/prices', config);
}

const get = async (id) => {
    return FinanceApi.get('/product/prices/' + id);
}

const store = async (data) => {
    if (data.id) {
        return FinanceApi.put('/product/prices/' + data.id, data);
    }
    return FinanceApi.post('/product/prices', data);
}

const update = async (id, formData) => {
    return FinanceApi.put('/product/prices/' + id, formData);
}

const deletePrices = async (code) => {
    return FinanceApi.delete('/product/prices/' + code);
}

const fileImport = async (data) => {
    return FinanceApi.post('/product/prices/import', data);
}

export default {
    getAll,
    get,
    store,
    update,
    deletePrices,
    fileImport
}
